// A collection of  CSS classes to compose the style from
export type Style = string;

// Defines a component that can have style applied
export interface Styleable {
  className?: Style;
}

// Convert styles into a string of class names
export function classNames(base: Style, other: Style): string {
  return `${base} ${other}`;
}
